import { getLocale } from '@websky/core/src/utils';
import i18next from 'i18next';
import { CardType } from '@websky/core/src/PromoLoader/types';
import { Locale } from '@websky/core/src/types';
import { doctorContentIcon, doctorHeaderIcon, medical_insurance } from './components/CheckoutAdditionalService/icons';
import { OauthServiceType } from '@websky/graphql';
import { Sorting } from '@websky/core/src/Results/enums';
const currentLocale = getLocale();
const isProd = process.env.NODE_ENV === 'production';
const passTypeRoutes = [
    [
        {
            departure: 'VVO',
            arrival: 'AER'
        }
    ],
    [
        {
            departure: 'AER',
            arrival: 'VVO'
        }
    ],
    [
        {
            departure: 'VVO',
            arrival: 'PKC'
        }
    ],
    [
        {
            departure: 'PKC',
            arrival: 'VVO'
        }
    ],
    [
        {
            departure: 'KHV',
            arrival: 'AER'
        }
    ],
    [
        {
            departure: 'AER',
            arrival: 'KHV'
        }
    ],
    [
        {
            departure: 'UUS',
            arrival: 'LED'
        }
    ],
    [
        {
            departure: 'LED',
            arrival: 'UUS'
        }
    ],
    [
        {
            departure: 'VVO',
            arrival: 'LED'
        }
    ],
    [
        {
            departure: 'LED',
            arrival: 'VVO'
        }
    ],
    [
        {
            departure: 'PKC',
            arrival: 'LED'
        }
    ],
    [
        {
            departure: 'LED',
            arrival: 'PKC'
        }
    ],
    [
        {
            departure: 'KHV',
            arrival: 'LED'
        }
    ],
    [
        {
            departure: 'LED',
            arrival: 'KHV'
        }
    ],
    [
        {
            departure: 'HTA',
            arrival: 'LED'
        }
    ],
    [
        {
            departure: 'LED',
            arrival: 'HTA'
        }
    ],
    [
        {
            departure: 'UUD',
            arrival: 'SVX'
        }
    ],
    [
        {
            departure: 'SVX',
            arrival: 'UUD'
        }
    ],
    [
        {
            departure: 'UUD',
            arrival: 'LED'
        }
    ],
    [
        {
            departure: 'LED',
            arrival: 'UUD'
        }
    ],
    [
        {
            departure: 'EGO',
            arrival: 'SIP'
        }
    ],
    [
        {
            departure: 'SIP',
            arrival: 'EGO'
        }
    ],
    [
        {
            departure: 'VOZ',
            arrival: 'SIP'
        }
    ],
    [
        {
            departure: 'SIP',
            arrival: 'VOZ'
        }
    ],
    [
        {
            departure: 'SVX',
            arrival: 'SIP'
        }
    ],
    [
        {
            departure: 'SIP',
            arrival: 'SVX'
        }
    ],
    [
        {
            departure: 'IJK',
            arrival: 'SIP'
        }
    ],
    [
        {
            departure: 'SIP',
            arrival: 'IJK'
        }
    ],
    [
        {
            departure: 'KZN',
            arrival: 'SIP'
        }
    ],
    [
        {
            departure: 'SIP',
            arrival: 'KZN'
        }
    ],
    [
        {
            departure: 'KVX',
            arrival: 'SIP'
        }
    ],
    [
        {
            departure: 'SIP',
            arrival: 'KVX'
        }
    ],
    [
        {
            departure: 'MCX',
            arrival: 'SIP'
        }
    ],
    [
        {
            departure: 'SIP',
            arrival: 'MCX'
        }
    ],
    [
        {
            departure: 'NBC',
            arrival: 'SIP'
        }
    ],
    [
        {
            departure: 'SIP',
            arrival: 'NBC'
        }
    ],
    [
        {
            departure: 'GOJ',
            arrival: 'SIP'
        }
    ],
    [
        {
            departure: 'SIP',
            arrival: 'GOJ'
        }
    ],
    [
        {
            departure: 'OMS',
            arrival: 'SIP'
        }
    ],
    [
        {
            departure: 'SIP',
            arrival: 'OMS'
        }
    ],
    [
        {
            departure: 'OSW',
            arrival: 'SIP'
        }
    ],
    [
        {
            departure: 'SIP',
            arrival: 'OSW'
        }
    ],
    [
        {
            departure: 'PEZ',
            arrival: 'SIP'
        }
    ],
    [
        {
            departure: 'SIP',
            arrival: 'PEZ'
        }
    ],
    [
        {
            departure: 'PEE',
            arrival: 'SIP'
        }
    ],
    [
        {
            departure: 'SIP',
            arrival: 'PEE'
        }
    ],
    [
        {
            departure: 'KUF',
            arrival: 'SIP'
        }
    ],
    [
        {
            departure: 'SIP',
            arrival: 'KUF'
        }
    ],
    [
        {
            departure: 'RTW',
            arrival: 'SIP'
        }
    ],
    [
        {
            departure: 'SIP',
            arrival: 'RTW'
        }
    ],
    [
        {
            departure: 'TJM',
            arrival: 'SIP'
        }
    ],
    [
        {
            departure: 'SIP',
            arrival: 'TJM'
        }
    ],
    [
        {
            departure: 'UFA',
            arrival: 'SIP'
        }
    ],
    [
        {
            departure: 'SIP',
            arrival: 'UFA'
        }
    ],
    [
        {
            departure: 'CEK',
            arrival: 'SIP'
        }
    ],
    [
        {
            departure: 'SIP',
            arrival: 'CEK'
        }
    ],
    [
        {
            departure: 'IAR',
            arrival: 'SIP'
        }
    ],
    [
        {
            departure: 'SIP',
            arrival: 'IAR'
        }
    ],
    [
        {
            departure: 'LPK',
            arrival: 'SIP'
        }
    ],
    [
        {
            departure: 'SIP',
            arrival: 'LPK'
        }
    ],
    [
        {
            departure: 'LED',
            arrival: 'SKX'
        }
    ],
    [
        {
            departure: 'SKX',
            arrival: 'LED'
        }
    ],
    [
        {
            departure: 'SVX',
            arrival: 'KGD'
        }
    ],
    [
        {
            departure: 'KGD',
            arrival: 'SVX'
        }
    ],
    [
        {
            departure: 'HTA',
            arrival: 'SVX'
        }
    ],
    [
        {
            departure: 'SVX',
            arrival: 'HTA'
        }
    ],
    [
        {
            departure: 'HTA',
            arrival: 'AER'
        }
    ],
    [
        {
            departure: 'AER',
            arrival: 'HTA'
        }
    ],
    [
        {
            departure: 'YKS',
            arrival: 'SVX'
        }
    ],
    [
        {
            departure: 'SVX',
            arrival: 'YKS'
        }
    ],
    [
        {
            departure: 'MJZ',
            arrival: 'SVX'
        }
    ],
    [
        {
            departure: 'SVX',
            arrival: 'MJZ'
        }
    ],
    [
        {
            departure: 'YKS',
            arrival: 'LED'
        }
    ],
    [
        {
            departure: 'LED',
            arrival: 'YKS'
        }
    ],
    [
        {
            departure: 'MJZ',
            arrival: 'LED'
        }
    ],
    [
        {
            departure: 'LED',
            arrival: 'MJZ'
        }
    ],
    [
        {
            departure: 'IKT',
            arrival: 'AER'
        }
    ],
    [
        {
            departure: 'AER',
            arrival: 'IKT'
        }
    ],
    [
        {
            departure: 'YKS',
            arrival: 'AER'
        }
    ],
    [
        {
            departure: 'AER',
            arrival: 'YKS'
        }
    ]
];
export const passengersConfig = [
    {
        code: 'ADT',
        isAdult: true,
        defaultCount: 1,
        noAvailableWith: ['SCF', 'SCM', 'МЛА']
    },
    {
        code: 'SCF',
        parentCode: 'ADT',
        isAdult: true,
        noAvailableWith: ['ADT'],
        onlyRoutes: passTypeRoutes
    },
    {
        code: 'SCM',
        parentCode: 'ADT',
        isAdult: true,
        noAvailableWith: ['ADT'],
        onlyRoutes: passTypeRoutes
    },
    {
        code: 'МЛА',
        parentCode: 'ADT',
        isAdult: true,
        noAvailableWith: ['ADT'],
        onlyRoutes: passTypeRoutes
    },
    {
        code: 'CLD',
        isAdult: false
    },
    {
        code: 'INF',
        isAdult: false,
        disabledRoutes: [
            [
                {
                    arrival: '*',
                    departure: 'AAQ'
                }
            ],
            [
                {
                    arrival: 'AAQ',
                    departure: '*'
                }
            ],
            [
                {
                    arrival: '*',
                    departure: 'NOI'
                }
            ],
            [
                {
                    arrival: 'NOI',
                    departure: '*'
                }
            ],
            [
                {
                    arrival: '*',
                    departure: 'GDZ'
                }
            ],
            [
                {
                    arrival: 'GDZ',
                    departure: '*'
                }
            ],
            [
                {
                    arrival: '*',
                    departure: 'АОС'
                }
            ],
            [
                {
                    arrival: 'АОС',
                    departure: '*'
                }
            ],
            [
                {
                    arrival: '*',
                    departure: 'БСК'
                }
            ],
            [
                {
                    arrival: 'БСК',
                    departure: '*'
                }
            ],
            [
                {
                    arrival: '*',
                    departure: 'АХЗ'
                }
            ],
            [
                {
                    arrival: 'АХЗ',
                    departure: '*'
                }
            ],
            [
                {
                    arrival: '*',
                    departure: 'ДМЙ'
                }
            ],
            [
                {
                    arrival: 'ДМЙ',
                    departure: '*'
                }
            ],
            [
                {
                    arrival: '*',
                    departure: 'ЭЛБ'
                }
            ],
            [
                {
                    arrival: 'ЭЛБ',
                    departure: '*'
                }
            ],
            [
                {
                    arrival: '*',
                    departure: 'ШГШ'
                }
            ],
            [
                {
                    arrival: 'ШГШ',
                    departure: '*'
                }
            ]
        ]
    },
    {
        code: 'INS',
        isAdult: false
    }
];
export const promoLoaders = [
    {
        type: CardType.City,
        image: 'https://cdn.websky.aero/content/frontend/images/WZ/promoLoader.jpg'
    }
];
const subscriptionLink = `https://flyredwings.com/${currentLocale}/subscription/`;
export const companyInfo = {
    subsidyFaresConditionURL: 'https://flyredwings.com/sub/dlya-kategorij-po-vozrastu/',
    facebook: 'https://www.facebook.com/flyredwings',
    instagram: 'https://www.instagram.com/flyredwings',
    vk: 'https://vk.com/flyredwings',
    baggage: `https://flyredwings.com/${currentLocale}/baggage/`,
    meal: `https://flyredwings.com/${currentLocale}/services/meal-on-board/`,
    seat: `https://flyredwings.com/${currentLocale}/services/choice-place/`,
    legal: `https://flyredwings.com/${currentLocale}/regulations/`,
    privacyPolicy: `https://flyredwings.com/${currentLocale}/privacy-policy/`,
    exarePrivacyPolicyURL: `https://flyredwings.com/${currentLocale}/regulations/`,
    exareRulesURL: `https://flyredwings.com/${currentLocale}/privacy-policy/`,
    insurance: `https://flyredwings.com/${currentLocale}/services/insurance/`,
    subsidyRulesUrl: `https://flyredwings.com/sub/dlya-kategorij-po-vozrastu/`,
    farelockURL: `https://flyredwings.com/services/fiksirovanie-stoimosti-aviabileta/`,
    transferBaggageUrl: `https://flyredwings.com/koltsovo/`,
    loyaltyProgramRegistrationUrl: ``,
    loyaltyProgramName: '',
    iataCode: 'WZ',
    loyalty: {
        links: [
            {
                title: 'Status',
                url: ``
            },
            {
                title: 'Earn miles',
                url: ``
            },
            {
                title: 'Use miles',
                url: ``
            },
            {
                title: 'FAQ',
                url: ``
            }
        ]
    },
    multiInsurance: true,
    specialDocumentForInsurance: false,
    hotelsURL: 'https://redwings.ostrovok.ru/hotels'
};
export const i18n = {
    ru: {
        LoginPage: {
            'Email / Phone / Card number': 'Эл. почта',
            'Please enter a valid Email / Phone / Card number': 'Пожалуйста введите Эл. почту'
        },
        FareLock: {
            'No need to worry about the price increase or about the fact that all tickets will be sold out, now you can fix the ticket price for {{hours}} {{plural}}': 'Не нужно беспокоиться о повышении цены или о том, что все билеты раскупят, сейчас вы можете зафиксировать цену авиабилета на {{hours}} {{plural}}',
            'Attention! Payment <strong>only with a plastic card</strong> (not SberPay)!': 'Внимание! Оплата <strong>только пластиковой картой</strong> (не SberPay)!',
            'Rules of service provision': 'Правила предоставления услуги'
        },
        Warnings: {
            [`Listed below meals serving and ingredients are guaranteed for flights, that depart from Sheremetyevo airport. For other flights meals can differ from listed above. At the same time you can be sure, that new ingredients don't differ in quality.`]: 'Подача и внешний вид блюда могут отличаться в зависимости от аэропорта вылета'
        },
        Baggage: {
            ZIA_pet_control_warning: 'В аэропорту Жуковского отсутствует ветеринарный контроль! С 24 августа 2017 года оформлять необходимую документацию на вывоз животного следует в других пограничных контрольных ветеринарных пунктах (аэропорт Шереметьево, Домодедово, Внуково, а также на базе Клинико-диагностического центра ФГБУ «ВГНКИ»). Важно: подобные справки действительны в течение 5 дней, включая день оформления. Мы не отказываем в перевозке животных из Жуковского, однако пассажиру надлежит прибыть в аэропорт с оформленными в другом месте документами.'
        },
        Meal: {
            'Add for all': 'Выбрать это питание для всех пассажиров'
        },
        PromoLoader: {
            'One moment please': 'Поиск рейса'
        },
        RetrieveBooking: {
            'Retrieve booking': 'Мои бронирования',
            'Booking ID': 'Номер билета или код бронирования',
            'Security code': 'Фамилия пассажира',
            Open: 'Найти заказ'
        },
        Refund: {
            'The money will be returned to the card used to pay for the ticket within 15 days': 'Деньги будут возвращены на карту, использованную при оплате билета, в течение 15 дней.\nДополнительные услуги невозвратные',
            NeedConfirm: 'Подтвердите возврат',
            'Successful refund. Confirmation and detalization have been sent to your e-mail': 'Успешный возврат. Детализация будет отправлена на ваш e-mail',
            'Request for refund': 'Запрос на возврат',
            'Successfully refund': 'Успешный возврат'
        },
        Exchange: {
            'Create request': 'Оплатить',
            'We couldn\'t find any flights for given dates': 'Пожалуйста, выберите другую дату вылета',
            'Successful payment': 'Успешная оплата',
            'Failed payment': 'Оплата не удалась'
        },
        InfoCard: {
            Add: 'Добавить документ'
        },
        Title: {
            companyName: 'Red Wings'
        },
        Stepbar: {
            Hotels: 'Отели'
        },
        Checkout: {
            'I accept the': 'Я согласен с условиями',
            'terms of tariff': 'тарифа',
            'terms of agreement': 'договора',
            'terms of insurances': 'страхования',
            'processing of my personal data': 'обработки персональных данных',
            'If you will not select a seat now, we will automatically select it for you upon check-in.': 'Сейчас самое время выбрать место на борту! Первые - выбирают самые комфортные кресла',
            'The top ones get the top seats!': 'Первые - выбирают самые комфортные кресла',
            'Feel the taste in flight!': 'Выбирайте собственное меню!',
            'I agree with subsidy fares and rules': 'Я ознакомлен с <a href="{{subsidyUrl}}" target="_blank">правилами и ограничениями по использованию субсидируемых тарифов</a>',
            'I agree with the rules for checking in transfer baggage at Koltsovo airport': 'Я согласен с <a href="{{transferBaggageUrl}}" target="_blank">правилами оформления трансферного багажа в аэропорту «Кольцово»</a>',
            'Write-off of funds is made in tenge': 'Списание денежных средств производится в тенге',
            Attention: 'Внимание',
            'Online doctor': 'Врач в поездку',
            'Medical insurance': 'Медицинское страхование',
            'Business lounge with VIP services': 'Бизнес-зал с предоставлением VIP услуг',
            'Fast Track': 'Fast Track',
            Consents_Main: 'Даю свое согласие со следующими правилами и условиями:',
            Consents_TermsOfAgreement: 'Договором и правилами воздушной перевозки',
            Consents_Insurance: 'Правилами и условиями страхования',
            Consents_PrivacyPolicy: '',
            Consents_Subscribed: `Даю согласие на получение <a href="${companyInfo.privacyPolicy}" target="_blank">рекламно-информационных рассылок и обработку персональных данных</a>`
        },
        PassengersConsents: {
            Consents_Main: 'Даю свое согласие со следующими правилами и условиями:',
            Consents_TermsOfTariff: `<span data-type="termsOfTariff">Условиями тарифа</span>, <a href="${companyInfo.legal}" target="_blank">договором и правилами воздушной перевозки</a>`,
            Consents_TermsOfAgreement: '',
            Consents_Insurance: '',
            Consents_PrivacyPolicy: '',
            Consents_Subscribed: `Даю согласие на получение <a href="${subscriptionLink}" target="_blank">рекламно-информационных рассылок и обработку персональных данных</a>`
        },
        MealPage: {
            'Feel the taste in flight': 'Выбирайте собственное меню!\n\n\n'
        },
        SeatMap: {
            'Pay attention!': 'Уважаемые пассажиры, пожалуйста, обратите внимание!',
            'The airline reserves the right to replace the aircraft.': '',
            'In the event of an aircraft replacement, passengers who have paid for the “seat selection” service will be provided with seats on the plane that are similar in price and comfort, while maintaining the following parameters': 'В случае замены воздушного судна по причинам, связанным с обеспечением безопасности полетов, Авиакомпания предоставит пассажирам, оплатившим услугу "выбор места" - места аналогичные по стоимости и комфорту. Пассажирам будут сохранены следующие условия:',
            '- Cost of services;': '— Расположение места на борту, с учетом прохода или иллюминатора;',
            '- Location of the place relative to the window / aisle;': '— Расположение кресла на первых рядах салона;',
            '- Joint seating, if one was originally selected;': '— Совместная рассадка пассажиров;',
            '- Placement in the front row of the cabin, if one was originally selected.': '— Стоимость услуги',
            'Less than 24 hours left before the flight': 'До вылета рейса осталось менее 24 часов.',
            'You can select seats using the online registration service after issuing tickets': 'Услуга «Выбор мест» для данного рейса будет доступна после покупки билета во время онлайн-регистрации'
        },
        PaymentForm: {
            'Credit or debit card': 'Картой онлайн\nили ваучером',
            Invoicebox: 'По счёту для организаций',
            Title_PayLate: 'В рассрочку без первоначального взноса, одобрение за полчаса',
            Header_PayLate: 'В рассрочку без первоначального взноса, одобрение за полчаса',
            Instalment: 'В рассрочку без первоначального взноса, одобрение за полчаса'
        },
        FlightPrice: {
            'Select from': 'от'
        },
        Passenger: {
            docNumber: 'Серия и номер документа',
            'Check if the input is correct': 'Проверьте правильность ввода',
            other: 'Другое',
            organizationName: 'Название Организации',
            personnelNumber: 'Табельный Номер',
            contacts: 'Контакты'
        },
        IncludedBaggage: {
            Equipment: 'Дополнительный багаж',
            'Need to bring sports, music or baby equipments?': `Вам нужно взять с собой <a href="https://flyredwings.com/${currentLocale}/baggage/sportivnoe-snaryazhenie/" target="_blank">спортивное оборудование</a> или <a href="https://flyredwings.com/${currentLocale}/baggage/perevozka-zhivotnyx/" target="_blank">домашнее животное</a>?`
        },
        SubsidySuggestPopup: {
            'Subsidy fares': 'Внимание'
        },
        SearchForm: {
            Aviatickets: 'Авиабилеты',
            Hotels: 'Отели',
            'I will pay with a foreign card': 'Я буду платить иностранной картой',
            'Offer hotels': 'Предлагать гостиницы'
        },
        BaggageTotalPriceBlock: {
            Add: 'Добавить',
            edit: 'Изменить',
            from: 'От',
            'More bags': 'Багаж'
        },
        DesktopFlight: {
            Select: 'Выбрать'
        },
        FlightCard: {
            'The flight operates': 'Рейс выполняет'
        },
        FlightInfoModalContent: {
            'Back to flights': 'Вернуться к перелетам',
            'Total duration': 'Общая продолжительность',
            'Scroll up': 'Наверх'
        },
        OrderCard: {
            'Review:Waiting for payment': 'Ожидает оплаты',
            'Review:Expires at': 'Истекает',
            'Review:Expires today at': 'Истекает сегодня в',
            'Account:Waiting for payment': 'Ожидает оплаты',
            'Account:expires at': 'Истекает',
            'Account:expires today at': 'Истекает сегодня в',
            'Check-in': 'Онлайн регистрация'
        },
        Passengers: {
            Teenagers: 'Подростки',
            'Young people from twelve to eighteen years old': 'Молодые люди от 12 до 18 лет'
        },
        PromoCode: {
            'I confirm that I am an employee of Rostech. Otherwise, the Carrier has the right to cancel the ticket.': 'Подтверждаю, что являюсь сотрудником Ростеха. В ином случае Перевозчик имеет право аннулировать билет.'
        },
        QuickSearchForm: {
            PDA_0: 'Подросток',
            PDA_1: 'Подростка',
            PDA_2: 'Подростков'
        },
        SearchFormDatepicker: {
            'Without back date': 'Обратный билет не нужен'
        },
        TransferInfo: {
            Terminal: 'Терминал',
            Change: 'Смена'
        },
        Consents: {
            agreement_rules: 'Я ознакомился(-лась) с {{links}}, оплатой данных доп. услуг, принимаю их и согласен с ними.',
            agreement_insurancesRules_sogaz: '<span><a href="https://flyredwings.com/upload/redwings/insurance/sogaz/rules.pdf" target="_blank">правилами страхования АО «СОГАЗ»</a></span>',
            agreement_insurancesRules_alpha: '<span><a href="https://www.alfastrah.ru/docs/rules_SP_230617.pdf" target="_blank">правилами АО «АльфаСтрахование»</a></span>',
            agreement_insurancesRules: '{{alphaGeneralRules}}{{sogazGeneralRules}}{{insurancesProductsLinks}}',
            agreement_interpolation: '{{insurancesRules}}',
            agreement_additionalInsuranceRules: '{{link}}',
            agreement_additionalInsuranceName: 'условиями публичной оферты «{{name}}»'
        }
    },
    en: {
        LoginPage: {
            'Email / Phone / Card number': 'Email',
            'Please enter a valid Email / Phone / Card number': 'Please enter a valid Email'
        },
        Stepbar: {
            Hotels: 'Hotels'
        },
        Baggage: {
            ZIA_pet_control_warning: 'Please note that there is no pet control service at Zhukovskiy Airport. You should to pass veterinary control and obtain required documents at other nearest airports: Sheremetyevo, Domodedovo, Vnukovo. Pet control documents is valid for 5 days.'
        },
        PromoLoader: {
            'One moment please': 'Flight Search'
        },
        FareLock: {
            'Rules of service provision': 'Rules of service provision',
            'Attention! Payment <strong>only with a plastic card</strong> (not SberPay)!': 'Attention! Payment <strong>only with a plastic card</strong> (not SberPay)!'
        },
        Warnings: {
            [`Listed below meals serving and ingredients are guaranteed for flights, that depart from Sheremetyevo airport. For other flights meals can differ from listed above. At the same time you can be sure, that new ingredients don't differ in quality.`]: `The serving and appearance of the dish may vary depending on the departure airport`
        },
        RetrieveBooking: {
            'Retrieve booking': 'My bookings',
            'Booking ID': 'Ticket number or booking id',
            'Security code': 'Last name',
            Open: 'Find booking'
        },
        Title: {
            companyName: 'Red Wings'
        },
        FlightPrice: {
            'Select from': 'from'
        },
        Checkout: {
            'I agree with subsidy rules': 'I agree with<a href="{{subsidyUrl}}" target="_blank"> subsidy rules</a>',
            'I agree with the rules for checking in transfer baggage at Koltsovo airport': 'I agree with <a href="{{transferBaggageUrl}}" target="_blank">rules for checking in transfer baggage at Koltsovo airport</a>',
            'Write-off of funds is made in tenge': 'Write-off of funds is made in tenge',
            Attention: 'Attention',
            'Online doctor': 'Online doctor',
            'Medical insurance': 'Medical insurance',
            'Business lounge with VIP services': 'Business lounge with VIP services',
            'Fast Track': 'Fast Track'
        },
        PassengersConsents: {
            Consents_Main: 'I give my consent to the following terms and conditions:',
            Consents_TermsOfTariff: `<span data-type="termsOfTariff">The fare conditions</span>, <a href="${companyInfo.legal}" target="_blank">contract, and air transport rules</a>`,
            Consents_TermsOfAgreement: '',
            Consents_Insurance: '',
            Consents_PrivacyPolicy: '',
            Consents_Subscribed: `I consent to receiving <a href="${subscriptionLink}" target="_blank">advertising and informational newsletters and the processing of personal data</a>`
        },
        IncludedBaggage: {
            Equipment: 'Extra baggage'
        },
        SubsidySuggestPopup: {
            'Subsidy fares': 'Attention'
        },
        BaggageService: {
            From: 'From',
            Total: 'Total',
            Edit: 'Edit',
            Cancel: 'Cancel',
            Confirm: 'Confirm',
            'Different for return flight': 'Different for return flight',
            'Transportation of skis / snowboards': 'Transportation of skis / snowboards',
            'Special inventory': 'Sport equipment'
        },
        DesktopFlight: {
            Select: 'Select'
        },
        FlightCard: {
            'The flight operates': 'The flight operates'
        },
        FlightInfoModalContent: {
            'Back to flights': 'Back to flights',
            'Total duration': 'Total duration',
            'Scroll up': 'Scroll up'
        },
        Forms: {
            'To check in for a Smartavia flight, please visit their official website': 'To check in for a Smartavia flight, please visit their official website'
        },
        OrderCard: {
            'Review:Waiting for payment': 'Waiting for payment',
            'Review:Expires at': 'Expires at',
            'Review:Expires today at': 'Review:Expires today at',
            'Account:Waiting for payment': 'Waiting for payment',
            'Account:expires at': 'expires at'
        },
        Passenger: {
            other: 'Other',
            'Latin symbols and digits': 'Latin symbols and digits',
            organizationName: 'Organization Name',
            personnelNumber: 'Personnel Number',
            contacts: 'Contacts'
        },
        Passengers: {
            Teenagers: 'Teenagers',
            'Young people from twelve to eighteen years old': 'Young people from twelve to eighteen years old',
            '12-18 years': '12-18 years'
        },
        PromoCode: {
            'I confirm that I am an employee of Rostech. Otherwise, the Carrier has the right to cancel the ticket.': 'I confirm that I am an employee of Rostech. Otherwise, the Carrier has the right to cancel the ticket.'
        },
        QuickSearchForm: {
            PDA: 'Teenager',
            PDA_plural: 'Teenagers'
        },
        Refund: {
            'Privacy Policy': 'privacy policy'
        },
        SearchFormDatepicker: {
            'Without back date': 'No return ticket needed',
            'Approximate prices for 1 person for 1 direction': 'Approximate offers for one person for direct flights'
        },
        TransferInfo: {
            Terminal: 'Terminal',
            Change: 'Change'
        },
        PaymentForm: {
            Title_PayLate: 'By in credit without down payment, approval within half an hour',
            Header_PayLate: 'By in credit without down payment, approval within half an hour',
            Instalment: 'By in credit without down payment, approval within half an hour'
        },
        SearchForm: {
            Aviatickets: 'Aviatickets',
            Hotels: 'Hotels',
            'I will pay with a foreign card': 'I will pay with a foreign card'
        },
        Consents: {
            agreement_rules: 'I have read the {{links}}, payment terms of these additional services. I accept them and agree with them.',
            agreement_insurancesRules_sogaz: '<span><a href="https://flyredwings.com/upload/redwings/insurance/sogaz/rules.pdf" target="_blank">rules of insurance of «SOGAZ»</a></span>',
            agreement_insurancesRules_alpha: '<span><a href="https://www.alfastrah.ru/docs/rules_SP_230617.pdf" target="_blank">rules of insurance of «AlfaStrakhovanie»</a></span>',
            agreement_insurancesRules: '{{alphaGeneralRules}}{{sogazGeneralRules}}{{insurancesProductsLinks}}',
            agreement_interpolation: '{{insurancesRules}}',
            agreement_additionalInsuranceRules: '{{link}}',
            agreement_additionalInsuranceName: 'terms of public offer «{{name}}»'
        }
    },
    kk: {
        Title: {
            companyName: 'Red Wings'
        },
        Checkout: {
            'Business lounge': 'Бизнес залы'
        },
        Consents: {
            agreement_rules: 'I have read the {{links}}, payment terms of these additional services. I accept them and agree with them.',
            agreement_insurancesRules: '<a href="https://www.alfastrah.ru/docs/rules_SP_230617.pdf" target="_blank">rules of insurance</a>, {{insurancesProductsLinks}}',
            agreement_interpolation: '{{insurancesRules}}',
            agreement_additionalInsuranceRules: '{{link}}',
            agreement_additionalInsuranceName: 'terms of public offer «{{name}}»'
        }
    },
    de: {
        Refund: {
            'Ticket price': 'Order price'
        },
        Consents: {
            agreement_rules: 'I have read the {{links}}, payment terms of these additional services. I accept them and agree with them.',
            agreement_insurancesRules: '<a href="https://www.alfastrah.ru/docs/rules_SP_230617.pdf" target="_blank">rules of insurance</a>, {{insurancesProductsLinks}}',
            agreement_interpolation: '{{insurancesRules}}',
            agreement_additionalInsuranceRules: '{{link}}',
            agreement_additionalInsuranceName: 'terms of public offer «{{name}}»'
        }
    },
    fr: {
        Consents: {
            agreement_rules: 'I have read the {{links}}, payment terms of these additional services. I accept them and agree with them.',
            agreement_insurancesRules: '<a href="https://www.alfastrah.ru/docs/rules_SP_230617.pdf" target="_blank">rules of insurance</a>, {{insurancesProductsLinks}}',
            agreement_interpolation: '{{insurancesRules}}',
            agreement_additionalInsuranceRules: '{{link}}',
            agreement_additionalInsuranceName: 'terms of public offer «{{name}}»'
        }
    },
    zh: {
        Consents: {
            agreement_rules: 'I have read the {{links}}, payment terms of these additional services. I accept them and agree with them.',
            agreement_insurancesRules: '<a href="https://www.alfastrah.ru/docs/rules_SP_230617.pdf" target="_blank">rules of insurance</a>, {{insurancesProductsLinks}}',
            agreement_interpolation: '{{insurancesRules}}',
            agreement_additionalInsuranceRules: '{{link}}',
            agreement_additionalInsuranceName: 'terms of public offer «{{name}}»'
        }
    }
};
export const defaultSteps = {
    flights: {
        label: i18next.t('Stepbar:Flights')
    },
    seats: {
        label: i18next.t('Stepbar:Seats')
    },
    baggage: {
        label: i18next.t('Stepbar:Baggage')
    },
    meal: {
        label: i18next.t('Stepbar:Meal')
    },
    passengers: {
        label: i18next.t('Stepbar:Passengers')
    },
    payment: {
        label: i18next.t('Stepbar:Payment')
    }
};
export const config = {
    global: {
        additionalResources: {
            scripts: ['https://secure.sirena-travel.ru/media/js/pg-additional-1.0.min.js'],
            extraScripts: []
        },
        socialAuthMethods: [
            {
                service: OauthServiceType.Vkontakte,
                isAvailable: true
            },
            {
                service: OauthServiceType.TinkoffID,
                isAvailable: true
            }
        ],
        authMethods: {
            phone: false,
            ffp: false
        },
        showIsActualizationResultOk: false,
        allowPromoCodes: true,
        companyInfo,
        maxBaggagePerPassenger: 4,
        yandexMetrikaId: isProd ? ['17480347', '98693817'] : undefined,
        varioqubId: isProd ? '98693817' : undefined,
        locale: Locale.Russian,
        insurance: {
            upsaleStrategy: ['checkout-before-payment'],
            multiplePriorityInsurances: true
        },
        i18n,
        reserveEngines: {
            siteUrl: `https://flyredwings.com/${currentLocale}`
        },
        findOrderURL: `https://flyredwings.com/${currentLocale}/booking/#/find/`,
        checkoutAdditionalService: {
            insurance: {
                insuranceProgramCodeMap: {
                    ['ON_TELEMED_NS_SR_2']: {
                        header: 'Online doctor',
                        headerIcon: doctorHeaderIcon,
                        contentIcon: doctorContentIcon,
                        color: '#F28D6D'
                    },
                    ['RW_VZR']: {
                        header: 'Medical insurance',
                        color: '#77C6B3',
                        headerIcon: null,
                        contentIcon: medical_insurance
                    }
                }
            }
        },
        purchasePredictionThreshold: 0.01,
        purchasePredictionThresholdMax: 1,
        showLeavePageModal: true
    },
    Account: {
        engineURL: 'https://flyredwings.com/booking/',
        showSubscribeCheckbox: true,
        showUserPhoneInput: false
    },
    Engine: {
        mealWarning: `Listed below meals serving and ingredients are guaranteed for flights, that depart from Sheremetyevo airport. For other flights meals can differ from listed above. At the same time you can be sure, that new ingredients don't differ in quality.`,
        promoLoaders: promoLoaders,
        defaultSteps,
        checkInEnabled: true,
        checkInURL: 'https://flyredwings.com/check-in',
        showRefundRedirectButton: true,
        showAvailableFaresOnly: true,
        resultsDefaultSorting: Sorting.FlightTime
    },
    SearchForm: {
        engineURL: 'https://flyredwings.com/booking/',
        showPriceGraph: true,
        showPricesInDatepicker: true,
        passengersConfig: passengersConfig,
        enableComplexRoute: false,
        requestCoordintates: {
            desktop: false
        },
        resultsURL: 'https://flyredwings.kz/booking/',
        offerHotels: true,
        offerHotelsSupplier: 'OSTROVOK',
        offerHotelsLink: 'https://redwings.ostrovok.ru/hotels',
        offerHotelsMainLink: 'https://redwings.ostrovok.ru',
        offerHotelsAdditionalId: '62c561aea0b084090d491722'
    },
    FlightStatus: {
        playMarketURL: '',
        appStoreURL: ''
    }
};
